import API from './api.js'

export default {
    async getCustomers() {
        try {
            let response = await API.HTTPS.get('/customers')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getMachines(folderId) {
        try {
            let response = await API.HTTPS.get('/customers/' + folderId + '/machines')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getCustomer(folderId) {
        try {
            let response = await API.HTTPS.get('/customers/' + folderId)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async postCustomer(data) {
        try {
            let response = await API.HTTPS.post('/customers', data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async putCustomer(id, data) {
        try {
            let response = await API.HTTPS.put('/customers/' + id, data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async deleteCustomer(id) {
        try {
            let response = await API.HTTPS.delete('/customers/' + id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}